import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';

import { getElementId } from '../../../../../../common/elements/utils/elementPropertyUtils';
import { getSelectedTaskIdSelector } from '../../../selector/selectionToolsSelector';
import useSheet from '../../../../../mobile/structural/sheet/hooks/useSheet';

// Components
import Icon from '../../../../../components/icons/Icon';
import ToolbarTool from '../../ToolbarTool';
import MobileReactionsSheet from '../../../../../element/reactions/popup/MobileReactionsSheet';

// Types
import { SheetId } from '../../../../../mobile/structural/sheet/sheetTypes';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { useGroupTranslator } from '../../../../../components/i18n/GroupTranslationContext';

type MobileReactionToolProps = {
    selectedElements: Immutable.List<ImMNElement>;
    name: string;
    gridSize: number;
};

const MobileReactionTool = (props: MobileReactionToolProps): ReactElement => {
    const { selectedElements, gridSize, name } = props;
    const translate = useGroupTranslator();
    const mobileName = translate('mobile.reaction', name ?? 'Reactions');

    const elementIds = selectedElements.map(getElementId).toArray();
    const selectedTaskListId = useSelector(getSelectedTaskIdSelector);
    const focusElementIds = selectedTaskListId ? [selectedTaskListId] : elementIds;

    const sheetProps = useSheet(SheetId.ReactionTool, selectedTaskListId);
    const { isSheetOpen, dispatchOpenSheet, dispatchCloseSheet } = sheetProps;

    return (
        <>
            <ToolbarTool name={mobileName} isOpen={isSheetOpen} onClick={dispatchOpenSheet}>
                <Icon gridSize={gridSize} name={`toolbar-reaction`} />
            </ToolbarTool>
            <MobileReactionsSheet
                gridSize={gridSize}
                sheetProps={sheetProps}
                closePopup={dispatchCloseSheet}
                elementIds={focusElementIds}
            />
        </>
    );
};

export default MobileReactionTool;
